import axios from 'axios';

export const REQUEST_CHORD_DATA = "REQUEST_CHORD_DATA"

export function requestChordData() {
    return {
        type: REQUEST_CHORD_DATA
    }
}

export function loadChordData() {
    return function(dispatch) {
        dispatch(requestChordData())

        axios.get('/data.json').then(result => {
            dispatch(chordDataLoaded(result.data))
        })
    }
}

export const CHORD_DATA_LOADED = "CHORD_DATA_LOADED"

export function chordDataLoaded(chordData) {
    return {
        type: CHORD_DATA_LOADED,
        chordData
    }
}


// WEBPACK FOOTER //
// ./src/Actions.js